import React, { useState } from "react";
import { sound } from "./sound";

/**
 * UrlLaunchBar: paste URL + List your link + helper.
 * Own Fold 1 grid node (not nested in CopyBlock) so mobile order is
 * copy → podium → URL; on desktop it stacks under the copy in column 1.
 * Opens the same overlay as TRANSMIT.
 */
export const UrlLaunchBar = ({ onOpenBid }) => {
  const [url, setUrl] = useState("");

  const launch = () => {
    sound.blip();
    onOpenBid(url.trim());
  };

  return (
    <div className="min-w-0">
      <div data-testid="url-launch-bar" className="url-launch-bar">
        <input
          data-testid="url-launch-input"
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              launch();
            }
          }}
          placeholder="https://yoursite.com"
          className="url-launch-input field mono px-3 py-2 text-sm"
        />
        <button
          type="button"
          data-testid="list-your-link-btn"
          onClick={launch}
          className="url-launch-cta cta-fuel mono whitespace-nowrap px-3 py-2 text-[10px] font-bold tracking-[0.12em] text-[#2a1000]"
        >
          List your link →
        </button>
      </div>
      <p className="url-launch-helper mono">
        We'll pull the name, description, and logo from your site.
      </p>
    </div>
  );
};
